import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { Heading, Text } from '@ui/themed';
import { t } from 'i18next';

const STEP_ORDER = ['priceList', 'customerGroup', 'customer'] as const;
export type B2BFlowStep = (typeof STEP_ORDER)[number];

export function B2BFlowDiagram({
  shopify,
  highlightStep,
}: {
  shopify: boolean;
  highlightStep: B2BFlowStep;
}) {
  return (
    <div className="flex w-full items-stretch gap-4">
      <DiagramStep
        step="priceList"
        highlightStep={highlightStep}
        title={t('components:b2b_flow_diagram.steps.price_list.title')}
        subtitle={t('components:b2b_flow_diagram.steps.price_list.subtitle')}
      />
      <DiagramConnector label={t('components:b2b_flow_diagram.connectors.assign')} />
      <DiagramStep
        step="customerGroup"
        highlightStep={highlightStep}
        title={t('components:b2b_flow_diagram.steps.customer_group.title')}
        subtitle={t('components:b2b_flow_diagram.steps.customer_group.subtitle')}
      />
      <DiagramConnector
        label={shopify ? t('components:b2b_flow_diagram.connectors.tag') : undefined}
      />
      <DiagramStep
        step="customer"
        highlightStep={highlightStep}
        title={t('components:b2b_flow_diagram.steps.customer.title')}
        subtitle={t('components:b2b_flow_diagram.steps.customer.subtitle')}
      />
    </div>
  );
}

function DiagramStep({
  step,
  highlightStep,
  title,
  subtitle,
}: {
  step: B2BFlowStep;
  highlightStep: B2BFlowStep;
  title: string;
  subtitle: string;
}) {
  return (
    <div className="flex flex-1 items-center gap-3 rounded-lg border border-platform-primary/15 bg-platform-primary/4 px-4 py-3">
      <span
        aria-hidden
        className={cn(
          'flex size-8 shrink-0 items-center justify-center rounded-lg font-semibold text-sm',
          step === highlightStep
            ? 'bg-platform-primary text-white'
            : 'bg-platform-primary/10 text-platform-primary',
        )}
      >
        {STEP_ORDER.indexOf(step) + 1}
      </span>
      <span className="flex min-w-0 flex-col">
        <Heading level="span" style="md">
          {title}
        </Heading>
        <Text size="sm" variant="secondary">
          {subtitle}
        </Text>
      </span>
    </div>
  );
}

function DiagramConnector({ label }: { label?: string }) {
  return (
    <div className="flex w-15 shrink-0 flex-col items-center gap-1 self-center">
      {label && (
        <span className="font-mono font-semibold text-spark-text-secondary text-xs">{label}</span>
      )}
      <span
        aria-hidden
        className="h-0.5 w-full bg-[repeating-linear-gradient(to_right,color-mix(in_srgb,currentColor_35%,transparent)_0_8px,transparent_8px_16px)] text-platform-primary"
      />
    </div>
  );
}
